/* eslint-disable */

import {
  EXAMPLE_ACCOUNT_USER_URL,
  EXAMPLE_ORGANISATION_ALPHA_ID,
  EXAMPLE_ORGANISATION_ALPHA_NAME,
  EXAMPLE_ORGANISATION_ALPHA_URL,
} from "../../services/constants";
import OrganisationLogo from "../organisation-logo/organisation-logo";
import RaindropTextHeading1 from "../raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";
import { useNavigate } from "react-router-dom";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";
import WaterfallIcon from "../waterfall-icon/waterfall-icon.tsx";
import FlexRow from "../flex-row/flex-row.tsx";
import FlexCol from "../flex-col/flex-col.tsx";
import Spacer from "../spacer/spacer.js";
import { Color } from "../../logic/enums.ts";
import ColorIndicator from "../color-indicator/color-indicator.tsx";
import PercentageDisplay from "../percentage-display/percentage-display.tsx";

const WaterfallListElement = ({
  id = "",
  urlUser = EXAMPLE_ACCOUNT_USER_URL,
  username = EXAMPLE_ORGANISATION_ALPHA_NAME,
  urlOrganisation = EXAMPLE_ORGANISATION_ALPHA_URL,
  title = "Hello world",
  color = Color.Raindrop,
  doShowColorIndicator = true,
  percentage = null,
  isClickable = false,
}) => {
  const navigate = useNavigate();

  return (
    <RaindropClickable
      onClick={() => {
        navigate(`/raindrop/waterfall/${id}`);
      }}
      isDisabled={!isClickable}
      additionalClasses="w-full"
    >
      <FlexRow tailwindGap="gap-4" className="w-full">
        <WaterfallIcon
          urlUser={urlUser}
          username={username}
          urlOrganisation={urlOrganisation}
        />
        <FlexCol tailwindGap="gap-0" className="w-full truncate ">
          <RaindropTextSubtitle className="w-full truncate">
            Waterfall
          </RaindropTextSubtitle>
          <RaindropTextHeading1 className="w-full truncate">
            {title}
          </RaindropTextHeading1>
        </FlexCol>

        {percentage && <PercentageDisplay value={percentage} max={100} />}
        <ColorIndicator doShow={doShowColorIndicator} color={color} />
      </FlexRow>
    </RaindropClickable>
  );
};

export default WaterfallListElement;
